import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AbstractRefreshTokenAdaptor } from '../../common/auth/auth-token/abstract-refresh-token.adaptor';
import { AuthSessionCheckFn } from '../../common/auth/auth-token/auth-session.guard';
import { AbstractLogoutAdaptor } from '../../common/auth/logout/abstract-logout.adaptor';
import { provideFetchAdaptor } from '../../common/fetch/fetch.directive';
import { provideFormAdaptor } from '../../common/form/form.directive';
import { AUTH_ROUTES } from './auth.routes';
import { AuthSessionCheckOnFocusFn } from './shared/auth-session-check-on-focus';
import { AuthTokenFetchAdaptor } from './shared/auth-token.adaptor';
import { LoginAdaptor } from './shared/login.adaptor';
import { LogoutAdaptor } from './shared/logout.adaptor';
import { ReferralFetchAdaptor } from './shared/referral-login/referral-fetch.adaptor';
import { ReferralLoginAdaptor } from './shared/referral-login/referral-login.adaptor';
import { RefreshTokenAdaptor } from './shared/refresh-token.adaptor';
import { RegisterAdaptor } from './shared/register.adaptor';
import { TncAdaptor } from './shared/tnc.adaptor';
import { TncRejectAdaptor } from './shared/tnc-reject.adaptor';

@NgModule({
  imports: [RouterModule.forChild(AUTH_ROUTES)],
  providers: [
    provideFormAdaptor(LoginAdaptor, true),
    provideFormAdaptor(RegisterAdaptor, true),
    provideFetchAdaptor(TncAdaptor, true),
    provideFetchAdaptor(TncRejectAdaptor, true),

    provideFetchAdaptor(AuthTokenFetchAdaptor),
    { provide: AbstractRefreshTokenAdaptor, useClass: RefreshTokenAdaptor },

    LogoutAdaptor,
    { provide: AbstractLogoutAdaptor, useExisting: LogoutAdaptor },
    { provide: AuthSessionCheckFn, useValue: AuthSessionCheckOnFocusFn },

    provideFetchAdaptor(ReferralFetchAdaptor, true),
    provideFormAdaptor(ReferralLoginAdaptor, true),
  ],
})
export class AuthModule {}
